<template>
  <div class="page-comment">
    <div class="title">评论（{{ contentDetail.comment_count }}）</div>
    <DetailComment
      :isPage="true"
      :detail="contentDetail"
      :user="contentDetail.user"
      :list="commentList"
      :pagination="pagination"
      :loadCommentStatus="loadCommentStatus"
      @getCommentList="getCommentList"
      @refresh="refresh"
      @setLoading="setLoading"
    />
  </div>
</template>
<script>
import Clipboard from "clipboard";
import calcMixin from "@/mixins/calcMixin";
import { mapGetters } from "vuex";
import DetailComment from "./detailComment";
import { apiCommentList } from "@/api/commentApi";
// api
import { apiContentLike } from "@/api/contentApi";
import { apiUserAddFavorite } from "@/api/userApi";

import { debounce } from "@/plugins/util";

export default {
  name: "fixedShare",
  mixins: [calcMixin],
  components: { DetailComment },
  props: {
    customStyle: {
      type: Object,
      default: () => ({})
    },
    // 从文章处传过来的文章id
    from: {
      type: String,
      default: ""
    },
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      contentDetail: {},
      commentVisible: false,
      // 评论列表
      commentList: [],
      pagination: {
        limit: 10,
        page_no: 0,
        page_total: 1,
        total: 0
      },
      loadCommentStatus: ""
    };
  },
  computed: {
    ...mapGetters(["gameInfo"])
  },
  watch: {
    detail: {
      handler(val) {
        this.contentDetail = val;
        this.getCommentList("refresh");
      },
      deep: true
    }
  },
  mounted() {
    window.addEventListener("scroll", this.loadMoreComment);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.loadMoreComment);
  },
  methods: {
    handleItem(type) {
      if (type === "editor") {
        this.goEdit();
      }
    },
    goEdit() {
      this.$router.push(
        `/${this.gameInfo.alias}/rich-table?id=${this.detail.id}&entry_id=${this.detail.entry_id}&title=${this.detail.title}`
      );
    },
    handleScroll() {},
    formatCount(count) {
      if (count >= 1000 && count < 10000) {
        return Math.floor(count / 1000) + "k+";
      } else if (count > 10000) {
        return Math.floor(count / 10000) + "w+";
      }
      return count;
    },
    openComment() {
      this.commentVisible = true;
      this.getCommentList();
    },
    loadMoreComment: debounce(function() {
      if (
        document.scrollingElement.scrollHeight -
          document.scrollingElement.scrollTop -
          document.scrollingElement.clientHeight <
        100
      ) {
        this.getCommentList();
      }
    }, 300),
    // 设置loading
    setLoading(loading) {
      this.loading = loading;
    },
    // 刷新详情
    refresh(detail, user) {
      if (detail) {
        this.$set(this, "contentDetail", detail);
      }
      if (user) {
        this.$set(this.contentDetail, "user", user);
      }
    },
    // 获取评论
    getCommentList: debounce(async function(type) {
      if (this.$route.params.id.includes("_")) return;
      if (type == "refresh") {
        this.pagination = {
          limit: 10,
          page_no: 0,
          page_total: 1,
          total: 0
        };
        this.commentList = [];
      }
      let { pagination } = this;
      if (pagination.page_no >= pagination.page_total) {
        this.loadCommentStatus = "end";
        return;
      }
      let { id } = this.$route.params;
      ++pagination.page_no;
      let params = {
        ...pagination,
        content_id: Number(id)
      };
      this.loadCommentStatus = "loading";
      await apiCommentList(params)
        .then(res => {
          if (res.code == 0) {
            this.commentList = this.commentList.concat(res.data);
            this.pagination = res.meta.pagination;
            this.contentDetail.comment_count = res.meta.pagination.total;
          }
        })
        .finally(_ => {
          this.loadCommentStatus = "";
        });
    }, 300),
    // 点赞
    onLike() {
      let params = {
        is_like: this.detail.is_like ? 0 : 1,
        origin_id: this.detail.id,
        type: 1
      };
      apiContentLike(params).then(res => {
        this.detail.is_like = params.is_like;
        params.is_like ? this.detail.like_count++ : this.detail.like_count--;
        if (this.detail.like_count < 0) this.detail.like_count = 0;
        this.$emit("refresh", this.detail);
      });
    },
    // 收藏文章
    onFavorite() {
      if (!this.isLoginShow()) return false;
      let params = {
        origin_id: this.detail.id,
        type: 1
      };
      apiUserAddFavorite(params).then(res => {
        if (res.code == 0) {
          this.detail.is_favorite = this.detail.is_favorite ? 0 : 1;
          this.detail.is_favorite ? this.detail.favorite_count++ : this.detail.favorite_count--;
          this.$emit("refresh", this.detail);
        }
      });
    },
    onShare() {
      let shareText = `${this.detail.user.username}分享了文章:${this.detail.title}\r\n`;
      shareText += window.location.href + "\r\n";
      shareText += "来自GameKee";

      let $div = document.createElement("div");
      $div.setAttribute("data-clipboard-text", shareText);
      $div.classList.add("page-share-copy-btn");
      document.body.appendChild($div);
      let clipboard = new Clipboard(".page-share-copy-btn");
      clipboard.on("success", e => {
        this.$message("复制成功！");
        document.body.removeChild($div);
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        this.$message("浏览器不支持自动复制,请更换其他浏览器");
        document.body.removeChild($div);
        clipboard.destroy();
      });
      $div.click();
    }
  }
};
</script>
<style lang="less" scoped>
.page-comment {
  position: relative;
  margin-top: 30px;
  .title {
    font-weight: 500;
    font-size: 16px;
    color: #fff;
    line-height: 52px;
    margin-bottom: 10px;
  }
  /deep/ .detail-comment {
    background-color: transparent;
    padding-top: 0;
  }
  /deep/ .article-edit-box {
    background-color: transparent;
    padding: 14px 10px;
  }
  /deep/ .wiki-comment-list {
    background-color: transparent;
    .no-more {
      color: #bebebe;
      text-align: center;
    }
  }
  /deep/ .wiki-comment-list .userAnswer {
    border-bottom: 1px solid rgba(233, 233, 233, 0.04);
    margin-right: 16px;
    .content {
      color: #bebebe;
    }
    .user-replay {
      .user-box .answer {
        color: #ceedfa;
      }
      .replay-content {
        color: #bebebe;
      }
    }
  }
  /deep/ .article-edit-box {
    color: #bebebe;
    height: initial;
    max-height: 100px;
    border-radius: 4px;
    &:empty:before {
      content: attr(placeholder);
      color: #5b6478;
      font-size: 13px;
    }
  }
  /deep/ .detail-comment {
    .article-edit-container {
      border: none;
      padding: 0;
      background-color: #20242e;
      .tool-bar {
        border-top: none;
        padding: 0;
        margin: 0;
        padding: 8px 10px;
        height: initial;
        .img-update-btn {
          width: initial;
        }
        .send-btn,
        .cancel-btn {
          padding: 6px 12px;
        }
        .cancel-btn {
          background-color: transparent;
          color: #fff;
        }
      }
      .img-group {
        padding: 10px;
        margin: 0;
      }
    }
  }
  /deep/ .dialog-comment-list .wiki-detail-comment {
    height: 70vh;
    display: flex;
    flex-direction: column;
    gap: 28px;
    .detail-comment {
      background-color: transparent;
      margin: 0;
      padding: 0;
    }
    .wiki-comment-list {
      flex-grow: 1;
      height: 0;
      background-color: transparent;
      margin: 0;
      padding: 0;
    }
  }
}
</style>
